export default "__VITE_ASSET__B6hGM5Zx__"